import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, BrowserRouter } from 'react-router-dom';
import App from './components/app';
import store from './config/store';
import { configAxios } from './config/axios';
import withTracker from './routes/with-tracker/index';

import './config/validation';

//import asyncComponent from './components/async'

//const App = asyncComponent(() =>
//    import('./components/app').then(module => module.default)
//)

// init axios interceptor
configAxios(store);

ReactDOM.render((
  <Provider store={store}>
    <BrowserRouter>
      <Route
        component={withTracker({
          component: App,
          componentProps: {
            token: store.getState().token
          }
        })}
      />
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js